import "../../../../styles/productView.scss";
import "../../../../styles/productViewListItem.scss";


import { Localization } from "../../../common/util/localization.jsx";
import ProductViewModal from "../product/ProductViewModal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll.jsx";
import TextField from "../../../common/components/TextField";
import { toLocaleFixed } from "../../../common/util/localization.jsx";

export class FreshFoodProductListHeader extends React.PureComponent {
    render() {
        const {
            localization,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <div className="container">
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("order", "view", "image")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={2}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("order", "view", "product")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("order", "view", "price")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("order", "view", "perPack")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>{localization.text("order", "template", "monday")}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>{localization.text("order", "template", "tuesday")}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>{localization.text("order", "template", "wednesday")}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>{localization.text("order", "template", "thursday")}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>{localization.text("order", "template", "friday")}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>{localization.text("order", "template", "saturday")}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>{localization.text("order", "template", "sunday")}</div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

FreshFoodProductListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
};

export class FreshFoodProductListItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onEdit = this.onEdit.bind(this);
        this.validateNewQty = this.validateNewQty.bind(this);
        this.checkDisabledDay = this.checkDisabledDay.bind(this);
        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
    }

    onEdit(change) {
        const {
            updateTemplateQty,
            product,
            templateData,
        } = this.props;
        updateTemplateQty(change, product, templateData.hubId);
    }

    validateNewQty() {
        return true;
    }

    showProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            localization,
            product,
            templateData,
        } = this.props;

        const productData = templateData.freshFoodProducts.find(p => p.productId === product.productId);
        this.props.setModal(<ProductViewModal localization={localization} product={productData} activeOrder={templateData} onAddProductChange={null} onCloseModal={this.closeProductModal} width={460}/>);
    }
    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.props.setModal(null);
    }

    checkDisabledDay(weekDay, thisweek, nextWeek)
    {
        const {
            templateData,
        } = this.props;

        const daysToCheck = thisweek ? templateData.disabledDaysThisWeek : nextWeek ? templateData.disabledDaysNextWeek : templateData.disabledDaysTemplate;
        
        return daysToCheck.some(d => d === weekDay);
    }

    render() {
        const {
            product,
            thisWeek,
            nextWeek,
        } = this.props;

        const propName = thisWeek ? "OrderedQtyCurrentWeek" : nextWeek ? "OrderedQtyNextWeek" : "TemplateQty";

        return (
            <div className="product-view-list-item-wrapper not-interactive" draggable={false}>
                <div className="container">
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={0} lg={1}>
                                <div className={"product-view-list-item-image-background"} style={{ cursor: "pointer" }} onClick={this.showProductModal}>
                                    {product.imageUrl && (
                                        <React.Fragment>
                                            <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                        </React.Fragment>
                                    )}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={0} lg={2}>
                                <div className="label14 product-view-list-item-prd-info_multiline" style={{ display: "flex", alignItems: "center" }} onClick={this.showProductModal}>
                                    <div style={{ width: "100%" }}>
                                        {product.productName}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item">
                                    <div style={{ width: "100%" }}>
                                        {toLocaleFixed(product.price,2)}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item">
                                    <div style={{ width: "100%" }}>
                                        {product.noOfSalesUnits}
                                    </div>
                                </div>
                            </ResponsiveColumn>                              
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-template">
                                    <TextField className="input-container" onEdit={this.onEdit} onChange={this.onEdit} smallText={true} darkBorder={true} source={product} property={`monday${propName}`} disabled={this.checkDisabledDay("monday", thisWeek, nextWeek)} type="number" min={0} validation={this.validateNewQty} />
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-template">
                                    <TextField className="input-container" onEdit={this.onEdit} onChange={this.onEdit} smallText={true} darkBorder={true} source={product} property={`tuesday${propName}`} disabled={this.checkDisabledDay("tuesday", thisWeek, nextWeek)} type="number" min={0} validation={this.validateNewQty} />
                                </div>
                            </ResponsiveColumn>   
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-template">
                                    <TextField className="input-container" onEdit={this.onEdit} onChange={this.onEdit} smallText={true} darkBorder={true} source={product} property={`wednesday${propName}`} disabled={this.checkDisabledDay("wednesday", thisWeek, nextWeek)} type="number" min={0} validation={this.validateNewQty} />
                                </div>
                            </ResponsiveColumn>   
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-template">
                                    <TextField className="input-container" onEdit={this.onEdit} onChange={this.onEdit} smallText={true} darkBorder={true} source={product} property={`thursday${propName}`} disabled={this.checkDisabledDay("thursday", thisWeek, nextWeek)} type="number" min={0} validation={this.validateNewQty} />
                                </div>
                            </ResponsiveColumn>   
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-template">
                                    <TextField className="input-container edit-template-qty" onEdit={this.onEdit} onChange={this.onEdit} smallText={true} darkBorder={true} source={product} property={`friday${propName}`} disabled={this.checkDisabledDay("friday", thisWeek, nextWeek)} type="number" min={0} validation={this.validateNewQty} />
                                </div>
                            </ResponsiveColumn>   
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-template">
                                    <TextField className="input-container" onEdit={this.onEdit} onChange={this.onEdit} smallText={true}  darkBorder={true} source={product} property={`saturday${propName}`} disabled={this.checkDisabledDay("saturday", thisWeek, nextWeek)} type="number" min={0} validation={this.validateNewQty} />
                                </div>
                            </ResponsiveColumn> 
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-template">
                                    <TextField className="input-container" onEdit={this.onEdit} onChange={this.onEdit} smallText={true}  darkBorder={true} source={product} property={`sunday${propName}`} disabled={this.checkDisabledDay("sunday", thisWeek, nextWeek)} type="number" min={0} validation={this.validateNewQty} />
                                </div>
                            </ResponsiveColumn>                            
                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

FreshFoodProductListItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    product: PropTypes.object,
    thisWeek: PropTypes.bool.isRequired,
    nextWeek: PropTypes.bool.isRequired,
    updateTemplateQty : PropTypes.func.isRequired,
    templateData : PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
};

FreshFoodProductListItem.defaultProps = {
};

class FreshFoodProductList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            width: null,
        };
        this.containerNode = null;
        this.prepareItems = this.prepareItems.bind(this);
    }

    prepareItems() {
        const {
            list,
            localization,
            setModal,
            thisWeek,
            nextWeek,
            updateTemplateQty,
            templateData,
        } = this.props;

        const retNodes = [];

        for (let i = 0; i < list.length; i++) {
            retNodes[retNodes.length] = (
                <FreshFoodProductListItem
                    key={i}
                    localization={localization}
                    product={list[i]}
                    setModal={setModal}
                    thisWeek={thisWeek}
                    nextWeek={nextWeek}
                    updateTemplateQty={updateTemplateQty}
                    templateData={templateData}
                />);
        }
        return retNodes;
    }

    render() {
        const {
            //deviceType,
            localization,
            height,
            style,
        } = this.props;

        const nodes = this.prepareItems();

        return (
            <React.Fragment>
                <div className={"product-view-header-wrapper"} >
                    <FreshFoodProductListHeader localization={localization} />
                </div>
                <Scroll style={{ height: height - 133, overflowX:"hidden", ...style }} className={"product-view-items-wrapper"} onCloseToBottom={this.trackScrolling} shadowStyle={{ borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }}>
                    {nodes}
                </Scroll>
            </React.Fragment>
        );
    }
}

FreshFoodProductList.propTypes = {
    height: PropTypes.number,
    // If true a loading icon will be displayed
    isLoading: PropTypes.bool,
    // An array of products to be displayed
    list: PropTypes.array.isRequired,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func.isRequired,
    style: PropTypes.object,
    thisWeek: PropTypes.bool.isRequired,
    nextWeek: PropTypes.bool.isRequired,
    template: PropTypes.bool.isRequired,
    updateTemplateQty : PropTypes.func.isRequired,
    templateData : PropTypes.object.isRequired,
};

export default FreshFoodProductList;
